// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; // For routing
import TermsAndConditions from './Components/TermsAndConditions'; // Import the new pages
import CancellationAndRefundPolicy from './Components/CancellationAndRefundPolicy';
import PiracyAndMisuseClause from './Components/PiracyAndMisuseClause';
import PrivacyPolicy from './Components/PrivacyPolicy';
import ShippingPolicy from './Components/ShippingPolicy'; // Added Shipping Policy
import Navigation from './Components/Navigation'; // Import navigation for links

function App() {
  return (
    <Router>
      <div>
        <Navigation />
        
        <Routes>
          <Route path="/knowledge-sun/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/knowledge-sun/Cancellation&RefundPolicy" element={<CancellationAndRefundPolicy />} />
          <Route path="/knowledge-sun/Piracy&MisuseClause" element={<PiracyAndMisuseClause />} />
          <Route path="/knowledge-sun/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/knowledge-sun/ShippingPolicy" element={<ShippingPolicy />} /> {/* Added Shipping Policy */}
          
          {/* Fallback route */}
          <Route path="*" element={<h2>Page Not Found</h2>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
